export default __webpack_public_path__ + "static/media/SZ04a.f32c406c.mp3";